import { Container } from "typescript-ioc";
import { ReadyHelper } from "Events/Scripts/ReadyHelper";
import { UiComponentFactory } from "Ui/Scripts/UiComponentFactory";
import { JoinUs } from "./JoinUs";

import "../Styles/join-us-simplified.css";
import "Navigation/Styles/popuplangswitcher.css";

Container.get(ReadyHelper).bindDomReady(() =>
    Container.get(UiComponentFactory).createBase(JoinUs, "body")
);
